module.exports = __webpack_public_path__ + "img/galleria12.ba2813ba.jpg";